export { RatingDots, type RatingDotsProps } from "./ui";
